<div class="flex flex-col h-full w-full overflow-hidden">
  <!-- Header -->
  <div class="flex justify-between items-center p-4 h-auto">
    <!-- Logo -->
    <div class="w-30 h-auto">
        <img class="w-90 h-auto" src="images/logo/logo.svg" />
    </div>

    <!-- Close button -->
     <button mat-icon-button (click)="closeDialog()" class="icon-size-2" *ngIf="false">
        <mat-icon>close</mat-icon>
    </button>
    
  </div>

  <!-- Main Content - Enhanced for better space distribution -->
  <div class="flex-grow flex flex-col h-full px-4 ">
    <!-- Top section with title and text -->
    <div class="flex flex-col items-center justify-center w-full pt-6 ">
      <h1 class="text-3xl sm:text-3xl font-extrabold leading-tight text-center">
        {{ 'register.validateEmailTitle' | transloco }}
      </h1>
      
    </div>
    
    <!-- Middle Section - Flexible space -->
    <div class="flex-grow flex flex-col justify-center items-center">
      <!-- Email input -->
      <div class="w-full max-w-2xl floating-label">
        <div class="mt-0.5 text-base sm:text-base font-medium text-gray-500 text-center">
        {{ 'register.validateEmailSubtitle' | transloco }}<br />
        <span class="font-semibold">{{ 'register.validateEmailSubtitle2' | transloco }}</span>
      </div>
    </div>

    <!-- Bottom section with button and text -->
    <div class="w-full max-w-md mx-auto mt-auto pb-6 ">
      <button 
        (click)="closeDialog()"
        class="w-full my-button py-4 text-white rounded-full font-semibold text-base md:text-base transition h-14 shadow btnactions-base bg-teal-700 hover:bg-teal-800"
      >
      {{'general.close' | transloco}}
      </button>
      <p class="text-base mt-3 text-center">
        {{ 'register.validateEmailNotFound' | transloco }} <br>
        <button (click)="sendEmailAgain()" class="text-[#006E75] hover:text-[#003E42] underline hover:underline">
          {{ 'register.validateEmailResend' | transloco }}
        </button>
      </p>
    </div>
  </div>
</div>